<!--Header -->
<div mat-dialog-title style="margin: unset">
    <div role="heading">
        <span *ngIf="newAttachment" translate>Add Attachment</span>
        <span *ngIf="!newAttachment || editAttachment == true" translate>Edit Attachment</span>
    </div>
    <div style="font-size: 10pt">
        {{attachment.AttachmentDescription}}
    </div>
</div>

<!-- Body -->
<mat-dialog-content>
    <!-- File Name or Description -->
    <form #form="ngForm">
        <tyl-form-field style="width: 100%" *ngIf="!V10" label="Description"
            [hint]="(attachment.Description ? 100 - attachment.Description.length : 100) + ' characters left'">
            <textarea matInput title="Description" id="descriptionField" name="File Description" #descriptionField
                [(ngModel)]="attachment.Description" [required]="requireDescription" maxlength="100"
                style="resize: none;"></textarea>
        </tyl-form-field>

        <tyl-form-field *ngIf="V10 && !forGradebook" label="File Description"
            [hint]="(attachment.FileDescription ? 100 - attachment.FileDescription.length : 100) + ' characters left'"
            style="width: 100%">
            <input matInput title="File Description" id="fileNameField" name="File Name" #descriptionField
                [required]="requireDescription" [(ngModel)]="attachment.FileDescription" />
        </tyl-form-field>

        <tyl-form-field *ngIf="V10 && forGradebook" label="Name" style="width: 100%">
            <input matInput title="Name" id="fileNameField" name="File Name" #inputField
                [(ngModel)]="attachment.FileName" />
        </tyl-form-field>

        <tyl-form-field style="width: 100%" *ngIf="V10 && forGradebook" label="Description"
            [hint]="(attachment.Description ? 100 - attachment.Description.length : 100) + ' characters left'">
            <textarea matInput title="Description" id="descriptionField" name="File Description"
                [(ngModel)]="attachment.FileDescription" maxlength="100" style="resize: none;"></textarea>
        </tyl-form-field>
    </form>

    <!-- Document Type (V9) -->
    <div *ngIf="!V10 && documentTypes != undefined && documentTypes.length > 0">
        <tyl-form-field label="Document Type" style="width:100%;">
            <mat-select [(value)]="documentTypeId" name="documentTypeId" id="documentTypeIdSelect" #documentTypeField>
                <mat-option *ngFor="let documentType of documentTypes; let i = index" value="{{documentType.Id}}">
                    <span>{{documentType.CodeDescription}}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>

    <!-- File Upload -->
    <div *ngIf="editAttachment == false">
        <add-file *ngIf="!forGradebook" [(fileString)]="attachment.MyFileBase64String"
            [(fileName)]="attachment.FileName" [(fileExtension)]="attachment.FileExtension"
            [(fileType)]="attachment.FileType" buttonLabel="Browse"></add-file>

        <add-file *ngIf="forGradebook" [(fileString)]="attachment.MyFileBase64String"
            [(fileName)]="attachment.OriginalFileName" [(fileExtension)]="attachment.FileExtension"
            [(fileType)]="attachment.FileType" buttonLabel="Browse"></add-file>
    </div>

    <!-- File Type -->
    <div *ngIf="V10 && documentTypes != undefined && documentTypes.length > 0">
        <tyl-form-field label="File Type">
            <mat-select [(value)]="documentTypeId" name="fileTypeId" id="fileTypeIdSelect" [required]="true" #documentTypeField>
                <mat-option *ngFor="let documentType of documentTypes; let i = index" value="{{documentType.Id}}">
                    <span>{{documentType.CodeDescription}}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>

    <div *ngIf="showPortalVisibility" style="padding-top:10px;">
        <mat-checkbox [(ngModel)]="attachment.ViewFileOnWebsite">Allow parent/student to view file on portal
        </mat-checkbox>
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>